import { render, staticRenderFns } from "./jobHistoriesTable.vue?vue&type=template&id=71ec6f11&scoped=true&"
import script from "./jobHistoriesTable.vue?vue&type=script&lang=js&"
export * from "./jobHistoriesTable.vue?vue&type=script&lang=js&"
import style0 from "./jobHistoriesTable.vue?vue&type=style&index=0&id=71ec6f11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ec6f11",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VDataTable,VTooltip})
